module.exports = {
    unsubEdm: {
        unsubSuccessHeading:
            'You have successfully unsubscribed from all Woolworths Supermarkets Online emails',
        instructions:
            'Please wait up to 5 business days for this to effect.',
        unsubNotes:
            'Please note, you can always re-subscribe to these emails at any time within the preferences section of your Woolworths online account.',
        loginLinkText:
            ' to view or change your preferences.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/unsub-edm.js